import { render, staticRenderFns } from "./MediaUploader.vue?vue&type=template&id=675b62b2&scoped=true"
import script from "./MediaUploader.vue?vue&type=script&lang=js"
export * from "./MediaUploader.vue?vue&type=script&lang=js"
import style0 from "./MediaUploader.vue?vue&type=style&index=0&id=675b62b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b62b2",
  null
  
)

export default component.exports